class SpecificNumbers {
  static goldenRatio() {
    const GOLDENRATIO =
      `61803398874989484820458683436563811772030917980576286213544862270
5260462818902449707207204189391137484754088075386891752126633862
223536931793180060766726354433389086595939582905638322661319928290267880`.replaceAll(
        "\n",
        "",
      );

    return [...GOLDENRATIO];
  }

  static PI() {
    const PI = `141592653589793238462643383279502884197169399375
1058209749445923078164062862089986280348
253421170679821480865132823066470938446095
50582231725359408128481117450284102701938521
105559644622948954930381964`.replaceAll("\n", "");

    return [...PI];
  }

  static euler() {
    const EULER = `718281828459045235360287471352662497757247093699
959574966967627724076630353547594571382178525166
427427466391932003059921817413596629043572900
33429526059563073813232862794349076323382988075319525101901`.replaceAll(
      "\n",
      "",
    );

    return [...EULER];
  }
}

export default SpecificNumbers;

